

import * as commonActions from "../constants/common";

export const updateLoading = (data) => {
	return {
		type: commonActions.UPDATE_LOADING,
		payload: data,
	};
};

export const otpVerification = (data) => {
	return {
		type: commonActions.SET_OTP_VERIFICATION,
		payload: data,
	};
};

export const set_active_step = (data) => {
	return {
		type: commonActions.SET_ACTIVE_STEP,
		payload: {
			activeStep: data,
		},
	};
};

export const updateSummary = (data) => {
	return {
		type: commonActions.UPDATE_SUMMARY,
		payload: data,
	};
};

export const showErrorMessage = (data) => {
	return {
		type: commonActions.SHOW_ERROR_MESSAGE,
		payload: data,
	};
};

export const updateIsLoggedIn = (data) => {
	return {
		type: commonActions.UPDATE_IS_LOGIN,
		payload: data,
	};
};

export const UpdateWelcomeKitDetails = (data) => {
	return {
		type: commonActions.UPDATE_WELCOME_KIT_DETAILS,
		payload: data,
	};
};

export const setPolicyType = (data) => {
	return {
		type: commonActions.SET_POLICY_TYPE,
		payload: data,
	};
};

export const setClaimPolicy = (data) => {
	return {
		type: commonActions.SET_CLAIM_POLICY,
		payload: data,
	};
};

export const setHasExposure = (data) => {
	return {
		type: commonActions.HAS_EXPOSURE,
		payload: data,
	};
};

export const setOtherInfo = (data) => {
	return {
		type: commonActions.SET_OTHER_INFO,
		payload: data,
	};
};

export const setDeclarationsData = (data) => {
	return {
		type: commonActions.SET_DEC_DATA,
		payload: data,
	};
};
export const setJWT = (data) => {
	return {
		type: commonActions.SET_JWT,
		payload: data,
	};
};


export const setRequestId = (data) => {
	return {
		type: commonActions.SET_REQUEST_ID,
		payload: data,
	};
};


export const setActiveStep = (data) => {
	return {
		type: commonActions.SET_ACTIVE_STEP,
		payload: data,
	};
};